import './src/styles/global.css';
import "@fontsource/source-sans-pro";
import "@fontsource/press-start-2p";
import "@fontsource/newsreader";